class PendingOrderModel extends App.Models.BaseModel {
    modelUrl = 'PendingOrder';
}

App.Models.PendingOrder = PendingOrderModel;

